import { useConfig } from "../../hooks/useConfig";
import { ROBINHOOD_EXPLORER_URL } from "../../wallets/chain";
import { Disclosures } from "./Disclosures";
import { Ledger } from "./Ledger";

/**
 * The public record: one row per closed quarter, then the disclosures that
 * make the rows checkable.
 */
export function Transparency() {
  const { config } = useConfig();
  const explorerUrl = config?.explorerUrl ?? ROBINHOOD_EXPLORER_URL;

  return (
    <div className="stack stack-6" id="transparency" style={{ marginTop: "var(--gap-8)" }}>
      <div className="stack stack-4">
        <h3>Transparency</h3>
        <p className="body">
          Each quarter gets a row: the transaction that claimed the fees, the transaction that sold
          them, the amount donated in Canadian dollars, the date, and whatever the charity sends
          back. Anyone can check the two transactions on Blockscout.
        </p>
        <Ledger explorerUrl={explorerUrl} />
      </div>
      <Disclosures />
    </div>
  );
}
